import FieldCheckbox from './FieldCheckbox';
import InputLabel from '../Inputs/InputLabel';
import React from 'react';

export default class FieldCheckboxGroup extends React.Component {
	/**
	 * @param {number} index
	 * @returns {boolean}
	 */
	#isLastValue(index) {
		return index === this.props.values.length - 1;
	}

	/**
	 * @returns {JSX.Element[]}
	 */
	#renderCheckboxes() {
		return Object.entries(this.props.values).map(
			([value, title], index) => (
				<li
					className={this.#isLastValue(index) ? '' : 'mr-2'}
					key={value}
				>
					<FieldCheckbox
						disabled={this.props.disabled}
						id={`${this.props.name}-${index + 1}`}
						label={title}
						name={`${this.props.name}`}
						required={this.props.required}
						value={value}
					/>
				</li>
			)
		);
	}

	render() {
		return (
			<section className="input-group checkbox-group">
				<InputLabel>{this.props.title}</InputLabel>

				<ul className="button-group my-5 w-fit">
					{this.#renderCheckboxes()}
				</ul>
			</section>
		);
	}
}
